import React from 'react'

import './index.scss'

const JourneyInfo = ({ reference, text, number, selected }) => (
  <div className={selected >= number ? 'journey__info journey__info--visible' : 'journey__info'}>
    <div ref={reference} className={number === selected ? 'journey__wrapper journey__wrapper--selected' : 'journey__wrapper'}>
      {text}
      <div>{number}</div>
    </div>
  </div>
)

export default JourneyInfo
